import { createContext, type ReactNode, useContext } from "react";

type EmbedContextValue = {
  isEmbed: boolean;
};

const EmbedContext = createContext<EmbedContextValue | null>(null);

export const EmbedProvider = ({ children }: { children: ReactNode }) => (
  <EmbedContext.Provider value={{ isEmbed: true }}>{children}</EmbedContext.Provider>
);

export function useEmbedContext() {
  const ctx = useContext(EmbedContext);
  if (!ctx) {
    throw new Error("useEmbedContext must be used inside EmbedProvider");
  }
  return ctx;
}
